/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Guidance_Have_IdInputs */



/**
* | output |
* | --- |
* | "Already have a VEKN ID?" |
*
* @param {Vekn_Guidance_Have_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_guidance_have_id = /** @type {((inputs?: Vekn_Guidance_Have_IdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Guidance_Have_IdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez déjà un VEKN ID ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Ya tienes un ID VEKN?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Já tem um ID VEKN?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai già un VEKN ID?")
	return /** @type {LocalizedString} */ ("Already have a VEKN ID?")
});